/**
 * Govino pack pricing.
 *
 * Glasses are bought in multiples of 2. The visible stepper counts glasses;
 * the hidden `quantity` field posts PAIRS, because the cart unit is the
 * 2-pack variant. The per-glass rate improves at each tier and then holds
 * flat from the last tier upward.
 *
 * Tiers come from snippets/govino-pack-tiers.liquid as "minGlasses:centsPerGlass".
 */
(function () {
  var STEP = 2;

  function parseTiers(raw) {
    return (raw || '')
      .split(',')
      .map(function (chunk) {
        var bits = chunk.split(':');
        return { min: parseInt(bits[0], 10), rate: parseInt(bits[1], 10) };
      })
      .filter(function (t) {
        return !isNaN(t.min) && !isNaN(t.rate);
      })
      .sort(function (a, b) {
        return a.min - b.min;
      });
  }

  /** Rate for a glass count: the best tier at or below it. Flat above the last. */
  function rateFor(tiers, glasses) {
    var rate = tiers[0].rate;
    for (var i = 0; i < tiers.length; i++) {
      if (glasses >= tiers[i].min) rate = tiers[i].rate;
    }
    return rate;
  }

  function activeTierMin(tiers, glasses) {
    var min = tiers[0].min;
    for (var i = 0; i < tiers.length; i++) {
      if (glasses >= tiers[i].min) min = tiers[i].min;
    }
    return min;
  }

  /** Snap to a valid multiple of STEP, never below the first tier. */
  function snap(value, floor) {
    var n = parseInt(value, 10);
    if (isNaN(n)) n = floor;
    n = Math.round(n / STEP) * STEP;
    return Math.max(floor, n);
  }

  function initPicker(root) {
    var tiers = parseTiers(root.dataset.tiers);
    if (!tiers.length) return;

    var floor = tiers[0].min;
    var input = root.querySelector('[data-gv-glasses]');
    var pairs = root.querySelector('[data-gv-pairs]');
    var totalEl = root.querySelector('[data-gv-total]');
    var rateEl = root.querySelector('[data-gv-rate]');
    var rows = root.querySelectorAll('[data-gv-tier-row]');
    if (!input || !pairs) return;

    // Money formatting mirrors the theme's Shopify.formatMoney when present,
    // otherwise falls back to the symbol the snippet handed us.
    var symbol = root.dataset.currency || 'R';
    function money(cents) {
      var amount = (cents / 100).toFixed(2);
      var parts = amount.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      return symbol + parts.join('.');
    }

    function render() {
      var glasses = snap(input.value, floor);
      input.value = glasses;

      var rate = rateFor(tiers, glasses);
      pairs.value = glasses / STEP;

      if (totalEl) totalEl.textContent = money(rate * glasses);
      if (rateEl) rateEl.textContent = money(rate) + ' each';

      var activeMin = activeTierMin(tiers, glasses);
      rows.forEach(function (row) {
        var isActive = parseInt(row.dataset.gvTierRow, 10) === activeMin;
        row.classList.toggle('is-active', isActive);
        if (isActive) {
          row.setAttribute('aria-current', 'true');
        } else {
          row.removeAttribute('aria-current');
        }
      });

      // Keep the form pointed at the 2-pack variant even if another
      // variant was selected before this block took over.
      var pairId = root.dataset.pairVariantId;
      if (pairId) {
        var form = root.closest('.product__info-container') || document;
        var idField = form.querySelector('.product-variant-id');
        if (idField && idField.value !== pairId) idField.value = pairId;
      }
    }

    root.querySelectorAll('[data-gv-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var delta = parseInt(btn.dataset.gvStep, 10);
        input.value = snap(parseInt(input.value, 10) + delta, floor);
        render();
      });
    });

    input.addEventListener('change', render);
    input.addEventListener('blur', render);

    render();
  }

  function init() {
    document.querySelectorAll('[data-gv-pack-picker]').forEach(initPicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init after section rendering (theme editor, variant change).
  document.addEventListener('shopify:section:load', init);
})();
